import { ReactElement } from 'react';

import { Route } from '@philips-emr/hpms-provider-accreditation-commons';
import { FetchAPI, FieldAPI } from '@philips-emr/tws-components';
import Controller, {  OnDynamicContentRender, OnMount, OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';
import {  SessionStorageService } from '@philips-emr/tws-core/lib/services';

import { NegotiationDetailsAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import { getStampByStatus, NegotiationData } from './negotiation-controller';
import { getStampStatusProposal, NegotiationType, ProposalData } from './negotiation-proposal-controller';

@Controller({ fragment: FragmentNames.NEGOTIATION_DETAILS })
class NegotiationDetailsController extends BaseController {

  @OnMount(Aliases.FETCH_NEGOTIATION)
  onMountFetch(event: MountEvent): void {
    const { nrSeqNegotiation } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqNegotiation });
    const api = event.target as FetchAPI;
    api.setParameters({ nrSeqNegotiation });
    api.forceFetch();
  }

  @OnDynamicContentRender(Aliases.FIELD_STATUS)
  onMountStatus(event: RenderEvent): void {
    const { data, render } = event;
    const { ieStatus, dsStatus } = data as NegotiationData;
    const content = (): ReactElement => (getStampByStatus(ieStatus, dsStatus));
    render(content);
  }

  @OnDynamicContentRender(Aliases.CARD_PROPOSALS)
  onRenderCardProposal(event: RenderEvent): void {
    const { data, render } = event;
    const { ieStatus, dsStatus } = data as ProposalData;
    const content = (): ReactElement => (getStampStatusProposal(ieStatus, dsStatus));
    render(content);
  }

  @OnMount(Aliases.FIELD_CANCEL_REASON)
  onMountCancelReason(event: MountEvent): void {
    const api = event.target as FieldAPI;
    const { dsCancelReason } = api.getData();
    if (!dsCancelReason) {
      api.setVisible(false);
    }
  }

  @OnSelectItem(Aliases.DECK_PROPOSALS)
  onClickCardVisit(event: SelectItemEvent<any>): void {
    const { nrSeqProposal, nrSeqClassification } = event.item as ProposalData;
    const { nrSeqNegotiation, nrSeqUser } = this.historyService.getCurrentRouteParams();
    SessionStorageService.setItem('nrSeqClassification', nrSeqClassification);

    if (nrSeqClassification == NegotiationType.PROPOSAL || nrSeqClassification == NegotiationType.READJUSTMENT) {
      this.historyService.push(Route.NEGOTIATION_PROPOSAL, { nrSeqProposal, nrSeqNegotiation, nrSeqUser });
    }

    if(nrSeqClassification == NegotiationType.DRAFT){
      this.historyService.push(Route.NEGOTIATION_PROPOSAL_DRAFT, { nrSeqProposal, nrSeqNegotiation, nrSeqUser });
    }
  }

}

export default NegotiationDetailsController;
